const base =
  'inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-full px-6 text-sm font-medium transition-[background-color,border-color,color,transform] duration-150 ease-out active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-clay focus-visible:ring-offset-2 focus-visible:ring-offset-paper disabled:pointer-events-none disabled:opacity-50';

export const btnPrimary = `${base} bg-ink text-paper hover:bg-clay`;
export const btnSecondary = `${base} border border-ink/25 bg-transparent text-ink hover:border-ink`;
export const btnClay = `${base} bg-clay text-paper hover:bg-clay-dark`;
export const linkUnderline =
  'underline decoration-ink/30 underline-offset-4 transition-[text-decoration-color] duration-150 hover:decoration-ink';
